import React from "react";
import Row from "@amzn/meridian/row";
import FooterButton from "./footerButton";
import Box from "@amzn/meridian/box";
import useBreakpoint from "@amzn/meridian/use-breakpoint";
import {
  MOBILE_BREAKPOINT,
  TABLET_BREAKPOINT,
  ELIGIBILITY_STATUS,
} from "../../constants/constants";
import { POLICY, HOME, ELIGIBLE_PRODUCT } from "../../constants/paths";
import "./footer.css";
import { getFooterIconDimension } from "../../utils/utils";
import useEligibilityContext from "../../context/useEligibilityContext";
import useProcessPathPairsContext from "../../context/useProcessPathPairsContext";
import { useBundle } from "@amzn/react-arb-tools";
import { HOMEPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const Footer = () => {
  const [bundle] = useBundle(HOMEPAGE_MESSAGE_BUNDLE_NAME);
  const { hasConfirmedEligibility } = useEligibilityContext();
  const { processPathPairs } = useProcessPathPairsContext();
  const isSiteEligible = processPathPairs.length !== 0;
  const showProduct = hasConfirmedEligibility === ELIGIBILITY_STATUS.YES;

  const isMobile = useBreakpoint(MOBILE_BREAKPOINT) === "smaller";
  const isTablet = useBreakpoint(TABLET_BREAKPOINT) === "smaller";
  const { height, width } = getFooterIconDimension(isMobile, isTablet);

  let footerWidths = ["fit", "250px", "120px"];

  if (isTablet) {
    footerWidths = ["fit", "180px", "100px"];
  }

  if (isMobile) {
    footerWidths = ["fit", "120px", "70px"];
  }

  return (
    <Row width={"100%"} widths={footerWidths}>
      <Box
        minHeight={height}
        minWidth={width}
        type="outline"
        className="footerIcon"
      ></Box>
      {showProduct ? (
        <FooterButton path={ELIGIBLE_PRODUCT}>
          {t(bundle, "eligible_products")}
        </FooterButton>
      ) : (
        <FooterButton path={HOME}>{t(bundle, "home")}</FooterButton>
      )}
      {isSiteEligible && (
        <FooterButton path={POLICY}>{t(bundle, "policy")}</FooterButton>
      )}
    </Row>
  );
};

export default Footer;
